// Credentials and authentication headers
export const credentialsInterceptor = {
   request: (config) => {
      config.withCredentials = true;

      // FormsV3 API uses different credential handling
      if (config.url.includes("/v1/")) {
         config.withCredentials = false;
         return config;
      }

      // Add App-Version header (hostname-based)
      const appKey = window.location.hostname;
      if (!config.url.includes("social-media-login")) {
         config.headers = {
            ...config.headers,
            "App-Version": appKey,
         };
      }

      return config;
   },
};
